<template>
  <el-main>
    <div class="mybread">
      <p><i class="el-icon-location"></i>当前位置：</p>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>客户/供应商管理</el-breadcrumb-item>
        <el-breadcrumb-item>供应商刊例</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="form">
      <el-form ref="form" label-width="100px" label-position="left">
        <el-form-item label="" style="margin-left: -100px;">
          <el-col :span="5">
            <el-select v-model="form.atype" placeholder="请选择类别" style="margin-right: 0; width: 100%;">
              <el-option label="供应商名称" value="vendor_name"></el-option>
              <el-option label="刊例描述" value="card_desc"></el-option>
            </el-select>
          </el-col>
          <el-col :span="12" style="margin-right: 10px;">
            <el-input placeholder="请输入内容" v-model="form.key" @keyup.enter.native="search" clearable @clear="search">
            </el-input>
          </el-col>
          <el-col :span="2">
            <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
          </el-col>
        </el-form-item>

        <el-form-item label="单价范围：" prop="price">
          <el-col :span="3">
            <el-input placeholder="请输入" maxlength="100" v-model="form.min_price" clearable style="width: 100%;"
              @blur="applySearch" />
          </el-col>
          <el-col :span="1">
            <div style="width: 100%; text-align: center;"> — </div>
          </el-col>
          <el-col :span="3">
            <el-input placeholder="请输入" maxlength="100" v-model="form.max_price" clearable style="width: 100%;"
              @blur="applySearch" />
          </el-col>
        </el-form-item>

        <el-form-item label="筛选：" prop="type">
          <el-col :span="5" style="margin-right: 20px;">
            <el-cascader v-model="form.cate_id_array" :options="selectTypeList" :props="{ expandTrigger: 'hover', checkStrictly: false }" @change="handleTypeChange" style="width: 100%;" clearable></el-cascader>
          </el-col>
        </el-form-item>

        <el-form-item label="已选条件">
          <el-tag v-for="tag in tags" :key="tag.key" effect="dark" closable @close="removeTag(tag)">
            {{ tag.key }}: {{ tag.value }}
          </el-tag>
        </el-form-item>
      </el-form>
    </div>

    <div class="table">
      <div class="filterwrap">
        <div>
          <el-button type="primary" icon="el-icon-shopping-cart-1" @click="link('/pubcase/sim')">计算器</el-button>
          <el-button @click="exportVendorCardListToExcel">导出数据</el-button>
        </div>
      </div>

      <el-table :data="itemList" border stripe style="width: 100%;" highlight-current-row>
        <el-table-column prop="vendor_name" label="供应商名称" header-align="center" align="center" min-width="150">
          <template slot-scope="scope">
            <el-link type='primary' class="link" @click="link(`/vendor/view?id=${scope.row.vendor_id}`)">{{ scope.row.vendor_name }}</el-link>
          </template>
        </el-table-column>
        <el-table-column prop="category" label="类型" header-align="center" align="center" min-width="90" >
          <template slot-scope="scope">
            {{ scope.row.category[0]?.category_name }}
          </template>
        </el-table-column>
        <el-table-column prop="category" label="类型" header-align="center" align="center" min-width="90" >
          <template slot-scope="scope">
            {{ scope.row.category[1]?.category_name }}
          </template>
        </el-table-column>
        <el-table-column prop="category" label="类型" header-align="center" align="center" min-width="90" >
          <template slot-scope="scope">
            {{ scope.row.category[2]?.category_name }}
          </template>
        </el-table-column>
        <el-table-column prop="card_desc" label="描述" header-align="center" align="center" min-width="200" />
        <el-table-column prop="price" label="单价" header-align="center" align="center" min-width="80" />
        <el-table-column prop="unit" label="单位" header-align="center" align="center" min-width="40" />
        <el-table-column prop="card_remarks" label="备注" header-align="center" align="center" min-width="200" />
        <el-table-column prop="" label="操作" header-align="center" align="center" width="100" fixed="right">
          <template slot-scope="scope">
            <div class="linkwrap">
              <el-link type='primary' class="link" @click="viewClick(scope)">添加到计算器</el-link>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="apage">
        <el-pagination @current-change="handleCurrentChange" :current-page="p" :page-size="30"
          layout="total, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
    </div>
  </el-main>
</template>

<script>
// CodeToText
import * as api from '@/api'
import store from '@/store'
export default {
  name: 'vendor',
  data() {
    return {
      nodeLimtList: [],
      level: '',
      realName: '',
      selectTypeList: [],
      itemList: [],
      total: 0,
      perPage: 30,
      p: 1,
      statusData: [],
      form: {
        key: '',
        atype: 'vendor_name',
      },
    }
  },
  computed: {
    tags() {
      let temp = [
        {
          key: this.dd.pubcaseType[this.form.atype],
          val: 'atype',
          value: this.form.key,
          active: !!this.form.atype && !!this.form.key,
        },
        {
          key: '单价范围',
          val: 'price',
          value: this.form.min_price + '-' + this.form.max_price,
          active: !!this.form.min_price && !!this.form.max_price,
        },
        {
          key: '物品类型',
          val: 'cate_id',
          value: this.form.cate_id,
          active: false,
        },
      ]
      temp = temp.filter((item) => item.active)
      return temp
    },
  },
  created() {
    this.statusData = this.$utils.objToOptions(this.$config.statusDataCard)
    this.getStoreFn()
  },
  mounted() {
    this.getSelectType().then(res => {
      this.selectTypeList = res
    })
  },
  methods: {
    checkUrlFn() {
      // 获取当前URL的哈希部分
      const hash = window.location.hash;
      // 移除'#'字符
      const url = hash.substring(1);

      let postData = {
        url_path: url
      }
      api.checkLoginUrl(postData).then((res) => {
        if (res.status == 400) {
          this.$message({
            type: 'info',
            message: '暂无权限',
          })
          this.$router.push({
            path: `/home`
          });
        }
      })
    },
    checkNodeFn(menu_id) {
      let postData = {
        menu_id,
      }
      api.checkNode(postData).then((res) => {
        this.nodeLimtList = res.node_ids.split(',')
      })
    },
    NodeInclude(val) {
      return this.nodeLimtList.includes(val)
    },

    exportVendorCardListToExcel() {
      window.location = api.exportVendorCardListToExcel({
        ...this.form,
        [this.form.atype]: this.form.key,//搜索
      })
    },

    dateValue(dateArr) {
      if (Array.isArray(dateArr)) {
        return this.fdate(dateArr[0]) + '-' + this.fdate(dateArr[1])
      } else {
        return ''
      }
    },
    link(url) {
      this.$router.push(url)
    },

    applySearch() {
      let from = parseInt(this.form.min_price)
      let to = parseInt(this.form.max_price)
      if (from > to && !isNaN(from) && !isNaN(to)) {
        this.form.min_price = from
        this.form.max_price = to
      }
      this.search()
    },

    search() {
      this.p = 1
      store.commit('setPubcaseData', JSON.parse(JSON.stringify(this.form)))
      this.getList()
    },

    getStoreFn() {
      this.form = Object.keys(store.state.pubcaseData).length != 0 ? store.state.pubcaseData : this.form
      this.getList()
    },

    // getSelectType() {
    //   this.$fly
    //     .post('ApiVendorCard_selectTypeList.html', { })
    //     .then((res) => {
    //       this.selectTypeList = res.length ? res : []
    //     })
    // },

    getSelectType(vid, cid) {
      const that = this;
      return new Promise(function (resolve) {
        that.$fly.post("ApiVendorCard_selectTypeList.html", {
          vendor_id: vid,
          cate_id: cid
        }).then((res) => {
          const selectTypeList = res.length ? res : [];
          resolve(selectTypeList)
        });
      })
    },

    getList() {
      // this.checkUrlFn()
      // this.checkNodeFn('61')
      const postData = {
        ...this.form,
        p: this.p,
        per_page: this.perPage,
        [this.form.atype]: this.form.key,//搜索
      }
      delete postData.cate_id_array
      api.getVendorCardList(postData).then((res) => {
        this.itemList = res.itemList
        this.total = +res.totalNum
        setTimeout(() => {
          //权限
          this.level = store.state.level
          this.realName = store.state.realName
        }, 200);
      })
    },
    removeTag(tag) {
      if (tag.val === 'cate_id') {
        this.form.cate_id_array = []
        this.form.cate_id = undefined
      }
      if (tag.val === 'price') {
        this.form.min_price = undefined
        this.form.max_price = undefined
      }
      !{
        type: () => {
          this.form['key'] = undefined
        },
      }[tag.val]?.()
      this.form[tag.val] = ''
      this.form.key = this.form.atype == '' ? '' : this.form.key
      store.commit('setPubcaseData', JSON.parse(JSON.stringify(this.form)))
      this.getList()
      console.log(tag)
    },
    handleCurrentChange(p) {
      this.p = p
      store.commit('setPubcaseData', JSON.parse(JSON.stringify(this.form)))
      this.getList()
    },
    handleTypeChange (e) {
      const trueId = e[e.length - 1]
      this.form.cate_id = trueId
      this.getList()
    },
    viewClick({row}) {
      // console.log(row);
      const {vendor_id, cate_id, card_desc, price, unit, cateInfo} = row
      let newItem = { vendor_id, cate_id, cate_id_array: JSON.parse(cateInfo.cate_id_json), card_desc, price, unit, number: 1, }
      this.getSelectType(vendor_id).then(res => {
        newItem.selectTypeList = res
        store.commit('setSimData', JSON.parse(JSON.stringify(newItem)))
        this.$router.push({
          path: '/pubcase/sim',
          query: { },
        })
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.filterwrap {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 0 0 20px 0;

  .filter {
    width: 85%;
  }

  .btnarea {
    box-sizing: border-box;
    width: 15%;
    padding: 0 20px;
    display: flex;
    justify-content: flex-end;
  }
}

.el-checkbox-group.filtergroup .el-checkbox {
  width: auto;
}

.apage {
  background: #f2f2f2;
  padding: 8px;
  text-align: right;
}

.el-select {
  margin-right: 20px;
}

.el-tag {
  margin-right: 20px;
  height: 36px;
  line-height: 36px;
  border: none;
}

.form {
  @extend %box;
  padding: 30px;
  margin-bottom: 20px;
}

.table {
  @extend %box;
  padding: 30px;
}

.linkwrap {
  font-size: 12px;

  &.normal {
    color: #606266;

    a {
      color: #606266;

      &:hover {
        &::after {
          height: 0.2px;
          background-color: #606266;
        }
      }

      >span {
        font-size: 12px;
        color: #606266;
      }
    }
  }
}
</style>
